import AddContractFromTemplate from './add-contract-from-template/PopupAddContractFromTemplate';
import BanLabelWarning from './ban-label-warning/PopupBanLabelWarning';
import CancelWarning from './cancel-warning/PopupCancelWarning';
import PopupChannelCreateForm from './channel-create/PopupChannelCreateForm';
import CodesParser from './codes-parser/CodesParserPopup';
import DeleteWarning from './delete-warning/PopupDeleteWarning';
import Form from './form/PopupForm';
import PopupImportPermissionsForm from './import-permissions/PopupImportPermissionsForm';
import PopupCheckPermissions from './check-permissions/PopupCheckPermissions';
import LabelResidanceCertificate from './label-residance-certificate/PopupLabelResidanceCertificateForm';
import OverwritingContractItems from './overriding-contract-items/PopupOverwritingContractItems';
import RemoveContractItem from './remove-contract-item/RemoveContractItemWIthChildrenPopup';
import Repayment from './repayment/RepaymentPopup';
import PopupUploadFile from './upload-file/PopupUploadFile';
import WarningPopup from './warning-popup/WarningPopup';
import FilePreviewPopup from './file-preview/FilePreviewPopup';
import CriticalWarningPopup from './critical-warning-popup/CriticalWarningPopup';

export default {
  DeleteWarning,
  BanLabelWarning,
  CancelWarning,
  LabelResidanceCertificate,
  PopupUploadFile,
  RemoveContractItem,
  OverwritingContractItems,
  AddContractFromTemplate,
  PopupChannelCreateForm,
  Form,
  PopupImportPermissionsForm,
  PopupCheckPermissions,
  WarningPopup,
  CriticalWarningPopup,
  CodesParser,
  Repayment,
  FilePreviewPopup
};
